<template>
  <component :is="'style'" v-if="user">
    a[data-user-id='{{ user.id }}'] { color: #3AB686 !important; }
  </component>
</template>

<script>
/**
 * This component adds global style to highlight logged-in user wherever mentioned
 */
export default {
  name: 'GlobalStyle',
  computed: {
    user() {
      return this.$store.getters.user
    }
  }
}
</script>

<style scoped></style>
